var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PaymentTitle',{attrs:{"type":"Add"}}),(_vm._fetchingStatus === _vm.requestStatus.PENDING)?_c('VLoader'):_vm._e(),(_vm._fetchingStatus === _vm.requestStatus.SUCCESS)?_c('HandlePaymentDetails'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }